import { useGetCarbonProgramByFarmId } from "utils";

import { BEEF_METHODOLOGY } from "models";

export const useBeefMethodology = (farmId?: string) => {
  const { data } = useGetCarbonProgramByFarmId(farmId);
  // Programs without a beef methodology are calculated with LfL by the API
  const beef = data?.farmLevelFootprinting?.methodology?.beef ?? BEEF_METHODOLOGY.LFL;
  return {
    isLfl: beef === BEEF_METHODOLOGY.LFL,
    isCfp: beef === BEEF_METHODOLOGY.CFP,
  };
};
